export default __webpack_public_path__ + "static/media/icon-nutrition.777d6d50.png";